import { FieldOptionBase } from 'api/tasks';
import { getValueStrOrValueAsNumber } from './get-value-valuestr';

export const getOptionsWithValueStr = (options: FieldOptionBase<any>[]) => {
  return options.map((op) => ({
    ...op,
    value: getValueStrOrValueAsNumber(op),
  }));
};
